import { dryFetch } from '../../utils/dryFetch';
import { getOwnerID, getOwnerJWT } from '../../utils/DryCookies';
// import track from '../utils/trackers';
import { hydrateChromeModelsClientDatabase, writeSystemValue } from '../offline';
import logger from '../../logger';

export const fetchChromeModelsFromCloud = async () => {
  // logger.info('fetchUserChromeModelFromCloud');
  // track.startTime('fetchUserChromeModelFromCloud');
  const ownerID = getOwnerID();
  const ownerJWT = getOwnerJWT();
  const myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${ownerJWT}`);

  try {
    const jsonResults = await dryFetch({
      name: 'fetchUserChromeModelFromCloud',
      path: `/chrome-models/${ownerID}`,
    });

    const {
      result: userChromeModels,
     } = jsonResults;
    // const completedTime = track.endTime('fetchUserChromeModelFromCloud');
    // logger.info({
    //   ownerID,
    //   time: completedTime,
    // }, 'fetchUserChromeModelFromCloud time');
    // track.time({
    //   category: 'user_chrome_models',
    //   name: 'fetch_user_chrome_models',
    //   value: completedTime,
    //   label: '',
    // });

    // store the key `utcDateTime` in userChromeModels as a local variable
    const utcDateTime = userChromeModels.utcDateTime;

    writeSystemValue({
      name: 'userChromeModelsLastSynced',
      utcDateTime: utcDateTime,
    });

    // Remove the key `utcDateTime` from userChromeModels
    delete userChromeModels.utcDateTime;

    const chromeModelsArray = Object.keys(userChromeModels).map((key) => {
      return {
        modelId: key,
        model: userChromeModels[key],
        utcDateTime,
      }
    });

    // Write the chrome models to IndexedDB
    await hydrateChromeModelsClientDatabase({ userChromeModels: chromeModelsArray });

    return userChromeModels;
  } catch (error) {
    logger.error(error);
    return error;
  }
};
